import React, { Component } from 'react';

export default class NiceImage extends Component {
  render() {
    let { mode, disabled, onClick, position, src, height, width, style, ...props } = this.props;

    const defaults = {
      height: height || "100%",
      width: width || "100%",
      cursor: disabled ? "default" : "pointer"
    };

    const backgroundStyle = {
      backgroundImage: `url("${src}")`,
      backgroundSize: mode || 'contain',
      backgroundPosition: position || 'center center',
      backgroundRepeat: 'no-repeat'
    };

    return <div style={{ ...defaults, ...backgroundStyle, ...style }} onClick={disabled ? null : onClick} {...props} />
  }
}
